import { Outlet } from 'react-router-dom';
import { AppUpdateBanner } from '@clarix/ui-shared';

/**
 * Router-level root layout — the one place shell-wide chrome that needs router
 * context can mount above EVERY tier of the route tree (admin, auth, invites,
 * onboarding, workspace).
 *
 * It can't live in App.tsx: `<RouterProvider>` takes no children, so anything
 * calling useLocation() has to be inside a route element.
 */
export function ShellRoot() {
  return (
    <>
      <Outlet />
      {/* Cache-staleness escape hatch. Correct cache headers keep a NEW page
          load from being stale, but they do nothing for a tab that was already
          open when a deploy landed — that session keeps running the old bundle
          until something forces a reload. This polls /version.json on navigation
          and tab focus and offers the reload instead of waiting for the user to
          discover the problem. See deploy/README.md → Cache policy. */}
      <AppUpdateBanner />
    </>
  );
}
